// extracted by mini-css-extract-plugin
export var askAiIcon = "_me-j";
export var category = "_me-9";
export var categoryHeader = "_me-e";
export var container = "_me-0";
export var group = "_me-a";
export var groupItems = "_me-f";
export var groupSeparator = "_me-k";
export var loading = "_me-1";
export var noResults = "_me-3";
export var placeholder = "_me-2";
export var resultContent = "_me-5";
export var resultIcon = "_me-c";
export var resultItem = "_me-g";
export var resultMeta = "_me-8";
export var resultSubtitle = "_me-7";
export var resultSuffix = "_me-i";
export var resultTitle = "_me-6";
export var resultsList = "_me-4";
export var searchGroup = "_me-d";
export var selected = "_me-h";
export var subgroup = "_me-b";